import { getAuth, signOut } from '@firebase/auth';
import { firebaseApp } from '../../FirebaseConfig';

export async function logoutUsecase(): Promise<[string, boolean]> {
  const auth = getAuth(firebaseApp);

  try {
    await signOut(auth);

    return ['', true];
  } catch (e) {
    console.error(e);
    return [e, false];
  }
}
